import Vue from "vue";
import VueRouter from "vue-router";
import MainAgenda from "../views/MainAgenda/index.vue";
import MainAgendaList from "../views/MainAgendaList/index.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  // 主日程
  {
    path: "/",
    name: "MainAgenda",
    component: MainAgenda,
    meta: {
      name: "日程列表",
    },
  },
  // 主日程列表模式
  {
    path: "/MainAgendaList",
    name: "MainAgendaList",
    component: MainAgendaList,
    meta: {
      name: "日程列表",
    },
  },
  // 主日程列表单页面
  {
    path: "/MainAgendaListsinglePage",
    name: "MainAgendaListsinglePage",
    component: () => import("../views/MainAgendaListsinglePage/index.vue"),
    meta: {
      name: "日程列表",
    },
  },
  // 日程通知确认
  {
    path: "/guestAgendaConfirm",
    name: "guestAgendaConfirm",
    component: () => import("../views/guestAgendaConfirm/index.vue"),
    meta: {
      name: "日程通知",
    },
  },
  // 日程通知嘉宾详情
  {
    path: "/guestDetail",
    name: "guestDetail",
    component: () => import("../views/guestAgendaConfirm/detail.vue"),
    meta: {
      name: "嘉宾详情",
    },
  },
  // 链接失效
  {
    path: "/rolesDel",
    name: "rolesDel",
    component: () => import("../views/rolesDel"),
    meta: {
      name: "链接失效",
    },
  },
  // 平台通知
  {
    path: "/platformNotifications",
    name: "platformNotifications",
    component: () => import("../views/platformNotifications"),
    meta: {
      name: "平台通知",
    },
  },
  // 子日程
  {
    path: "/subpages",
    name: "subpages",
    component: () => import("../views/Subpages/index.vue"),
    meta: {
      name: "会议日程详情",
    },
    children: [
      // 子日程
      {
        path: "/subpages",
        name: "subAgenda",
        component: () => import("../views/Subpages/subAgenda/index.vue"),
        meta: {
          name: "日程详情",
        },
      },
      // 嘉宾日程
      {
        path: "/subpages/guestAgenda",
        name: "guestAgenda",
        component: () => import("../views/Subpages/guestAgenda/index.vue"),
        meta: {
          name: "嘉宾日程",
        },
      },
      // 嘉宾搜索
      {
        path: "/subpages/guestSearch",
        name: "guestSearch",
        component: () => import("../views/Subpages/guestSearch/index.vue"),
        meta: {
          name: "嘉宾搜索",
        },
      },
      // 日程搜索
      {
        path: "/subpages/agendaSearch",
        name: "agendaSearch",
        component: () => import("../views/Subpages/agendaSearch/index.vue"),
        meta: {
          name: "日程搜索",
        },
      },
      // 嘉宾简介
      {
        path: "/subpages/guestAgenda/guestProfile",
        name: "guestProfile",
        component: () => import("../views/Subpages/guestProfile/index.vue"),
        meta: {
          name: "嘉宾简介",
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

let key = 1;

router.beforeEach(async (to, from, next) => {

  // 清除空参数
  let flag = 0;
  Object.keys(to.query).forEach((key) => {
    if (to.query[key] === "undefined" || to.query[key] === "") {
      delete to.query[key];
      flag = 1;
    }
  });

  console.log(to.query);
  await store.dispatch('getAgendaConfig', to.query.event_id)
  console.log('roter', to.query.event_id);
  if (store.state.agendaConfig.show_type != 1) {
    if (store.state.agendaConfig.show_type == 2) {
      if (to.path == '/MainAgendaList') {
        next({ path: '/', query: to.query })
        return
      }
    } else if (store.state.agendaConfig.show_type == 3) {
      if (to.path == '/') {
        next({ path: '/MainAgendaList', query: to.query })
        return
      }
    }
  }

  if (flag === 1) {
    router.push({ path: to.path, query: to.query });
  } else {
    next();
  }
});

export default router;
